"use client";

import { GlobalScrollbar } from "mac-scrollbar";
import "mac-scrollbar/dist/mac-scrollbar.css";

export default function ScrollbarWrapper() {
  return <GlobalScrollbar />;
}
